import React, { FC } from 'react';
import { Box, Paper } from '@mui/material';
import { BeneficiaryView } from 'services/beneficiaries.service';
import BeneficiaryRow from './BeneficiaryRow';

type BeneficiaryTableProps = {
  data: BeneficiaryView[];
  onEdit: (id: number) => void;
};

const BeneficiaryTable: FC<BeneficiaryTableProps> = ({ data, onEdit }) => {
  return (
    <Paper elevation={0} sx={{ mb: 0, p: 0, boxShadow: 'none', border: 'none', backgroundColor: 'transparent' }}>
      <Box>
        {data.map((counterparty) => (
          <BeneficiaryRow key={counterparty.id} counterparty={counterparty} onEdit={onEdit} />
        ))}
      </Box>
    </Paper>
  );
};

export default BeneficiaryTable;
